/**
 * Phase C — shortcut chip catalogs (v5.5).
 * Each chip is {key, label, mode, filters}.
 *   mode: "new" | "used" | "any" — informs which pages should show it.
 *   filters: query param overrides (merged into baseFilters when clicked).
 */

export const NEW_CHIPS = [
  { key: "suvs", label: "New SUVs", filters: { body_style: "suv" } },
  { key: "trucks", label: "New Trucks", filters: { body_style: "truck" } },
  { key: "evs", label: "New EVs", filters: { fuel_type: "electric" } },
  { key: "trax", label: "Trax", filters: { model: "Trax" } },
  { key: "equinox", label: "Equinox", filters: { model: "Equinox" } },
  { key: "equinox-ev", label: "Equinox EV", filters: { model: "Equinox EV" } },
  { key: "blazer", label: "Blazer", filters: { model: "Blazer" } },
  { key: "blazer-ev", label: "Blazer EV", filters: { model: "Blazer EV" } },
  { key: "traverse", label: "Traverse", filters: { model: "Traverse" } },
  { key: "tahoe", label: "Tahoe", filters: { model: "Tahoe" } },
  { key: "suburban", label: "Suburban", filters: { model: "Suburban" } },
  { key: "silverado-1500", label: "Silverado 1500", filters: { model: "Silverado 1500" } },
  { key: "silverado-hd", label: "Silverado HD", filters: { search: "Silverado HD" } },
  { key: "silverado-ev", label: "Silverado EV", filters: { model: "Silverado EV" } },
  { key: "colorado", label: "Colorado", filters: { model: "Colorado" } },
  { key: "corvette", label: "Corvette", filters: { model: "Corvette" } },
  { key: "3rd-row", label: "3rd Row SUVs", filters: { search: "3rd row" } },
  { key: "crew-cab", label: "Crew Cab Trucks", filters: { body_style: "truck", search: "crew cab" } },
  { key: "4x4", label: "4x4 Trucks", filters: { body_style: "truck", drivetrain: "4WD" } },
  { key: "diesel", label: "Diesel Trucks", filters: { body_style: "truck", fuel_type: "diesel" } },
  { key: "z71", label: "Z71", filters: { search: "Z71" } },
  { key: "trail-boss", label: "Trail Boss", filters: { search: "Trail Boss" } },
  { key: "high-country", label: "High Country", filters: { search: "High Country" } },
  { key: "available-now", label: "Available Now", filters: { availability: "available" } },
  { key: "under-30k", label: "Under $30,000", filters: { max_price: 30000 } },
  { key: "payment-under-500", label: "Payment Under $500", filters: { max_payment: 500 } },
];

export const USED_CHIPS = [
  { key: "used-under-10", label: "Under $10k", filters: { max_price: 10000 } },
  { key: "used-under-15", label: "Under $15k", filters: { max_price: 15000 } },
  { key: "used-under-20", label: "Under $20k", filters: { max_price: 20000 } },
  { key: "used-under-25", label: "Under $25k", filters: { max_price: 25000 } },
  { key: "used-suvs", label: "Used SUVs", filters: { body_style: "suv" } },
  { key: "used-trucks", label: "Used Trucks", filters: { body_style: "truck" } },
  { key: "used-4x4", label: "Used 4x4", filters: { body_style: "truck", drivetrain: "4WD" } },
  { key: "used-crew-cab", label: "Used Crew Cab", filters: { body_style: "truck", search: "crew cab" } },
  { key: "used-double-cab", label: "Used Double Cab", filters: { body_style: "truck", search: "double cab" } },
  { key: "used-diesel", label: "Used Diesel", filters: { fuel_type: "diesel" } },
  { key: "used-hd", label: "Used HD Trucks", filters: { search: "HD" } },
  { key: "used-long-bed", label: "Long Bed", filters: { search: "long bed" } },
  { key: "used-3rd-row", label: "Used 3rd Row", filters: { search: "3rd row" } },
  { key: "used-under-20k-mi", label: "Under 20k miles", filters: { max_mileage: 20000 } },
  { key: "used-under-50k-mi", label: "Under 50k miles", filters: { max_mileage: 50000 } },
  { key: "used-under-100k-mi", label: "Under 100k miles", filters: { max_mileage: 100000 } },
  { key: "high-mileage-value", label: "High-Mileage Value", filters: { min_mileage: 100000 } },
  { key: "budget", label: "Budget Used", filters: { max_price: 15000 } },
  { key: "new-arrivals", label: "New Arrivals", filters: { sort: "newest" } },
  { key: "local-trades", label: "Local Trades", filters: { search: "local trade" } },
];
